var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchWhite = function SvgSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.304 19.88a9.845 9.845 0 0 1-5.28 1.53C5.487 21.41 1 16.841 1 11.205S5.488 1 11.023 1c5.536 0 10.023 4.569 10.023 10.205 0 2.793-1.102 5.325-2.888 7.167l4.497 4.579c.46.468.46 1.229 0 1.697a1.164 1.164 0 0 1-1.668 0l-4.683-4.768zm2.384-8.675c0 4.31-3.432 7.804-7.665 7.804-4.233 0-7.665-3.494-7.665-7.804 0-4.31 3.432-7.804 7.665-7.804 4.233 0 7.665 3.494 7.665 7.804z",
    fill: "#fff",
    stroke: "#fff"
  })));
};
export default SvgSearchWhite;